// ** React Imports
import { useState, useEffect } from "react"
import { useLocation, useParams } from "react-router-dom"

// ** Store & Actions
import { useSelector, useDispatch } from "react-redux"
import {
  handleMenuCollapsed,
  handleContentWidth,
  handleMenuHidden
} from "../../redux/layout"

// ** Third Party Components
import classnames from "classnames"
import { ArrowUp } from "react-feather"

// ** Reactstrap Imports
import { Navbar, Button } from "reactstrap"

// ** Configs
import themeConfig from "../../configs/themeConfig"

// ** Custom Components

import Customizer from "../../@core/components/customizer"
import ScrollToTop from "../../@core/components/scrolltop"
import FooterComponent from "./components/footer"
import NavbarComponent from "./components/navbar"
import SidebarComponent from "./components/menu/vertical-menu"

// ** Custom Hooks
import { useRTL } from "../../utility/hooks/useRTL"
import { useSkin } from "../../utility/hooks/useSkin"
import { useLayout } from "../../utility/hooks/useLayout"
import { useNavbarType } from "../../utility/hooks/useNavbarType"
import { useFooterType } from "../../utility/hooks/useFooterType"
import { useNavbarColor } from "../../utility/hooks/useNavbarColor"


// ** Styles
import "../scss/base/core/menu/menu-types/vertical-menu.scss"
import "../scss/base/core/menu/menu-types/vertical-overlay-menu.scss"

import GlobalVariable from "../../settings/global"
import ChatbotWidget from "../../views/ChatBot/ChatbotWidget"
// import { isUserLoggedIn } from "../../utility/Utils"
// const headerText = GlobalVariable.headerText

const VerticalLayout = (props) => {
  // const isEmployee = isUserLoggedIn() && JSON.parse(isUserLoggedIn())?.isEmployee
  // ** Props
  const { menu, navbar,
    footer,
    children, menuData } = props
  const { catCode } = useParams()

  // ** Hooks
  const [isRtl, setIsRtl] = useRTL()
  const { skin, setSkin } = useSkin()
  const { navbarType, setNavbarType } = useNavbarType()
  const { footerType, setFooterType } = useFooterType()
  const { navbarColor, setNavbarColor } = useNavbarColor()
  const { layout, setLayout, setLastLayout } = useLayout()

  // ** States
  const [isMounted, setIsMounted] = useState(false)
  const [menuVisibility, setMenuVisibility] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  // ** Vars
  const dispatch = useDispatch()
  const layoutStore = useSelector((state) => state.layout)
  // const stores = useSelector((state) => state.commonreducerSlice)
  // const store = useSelector((state) => state)
  // ** Update Window Width
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }

  // ** Vars
  const location = useLocation()
  const isHidden = layoutStore.menuHidden
  const contentWidth = layoutStore.contentWidth
  const menuCollapsed = layoutStore.menuCollapsed

  // ** Toggles Menu Collapsed
  const setMenuCollapsed = (val) => dispatch(handleMenuCollapsed(val))

  // ** Handles Content Width
  const setContentWidth = (val) => dispatch(handleContentWidth(val))

  // ** Handles Content Width
  const setIsHidden = (val) => dispatch(handleMenuHidden(val))

  //** This function will detect the Route Change and will hide the menu on menu item click
  useEffect(() => {
    // console.log("Route Changed", location.pathname, location)
    if (menuVisibility && windowWidth < 1200) {
      setMenuVisibility(false)
    }
  }, [location.pathname, location.search])

  //** Sets Window Size & Layout Props
  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth)
    }
  }, [windowWidth])

  //** ComponentDidMount
  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  // ** Vars
  const footerClasses = {
    static: "footer-static",
    sticky: "footer-fixed",
    hidden: "footer-hidden"
  }

  const navbarWrapperClasses = {
    floating: "navbar-floating",
    sticky: "navbar-sticky",
    static: "navbar-static",
    hidden: "navbar-hidden"
  }
  const navbarClasses = {
    floating:
      contentWidth === "boxed" ? "floating-nav" : "floating-nav",
    sticky: "fixed-top",
    static: "navbar-static-top",
    hidden: "d-none"
  }

  const bgColorCondition =
    navbarColor !== "" && navbarColor !== "light" && navbarColor !== "white"

  if (!isMounted) {
    return null
  }
  return (
    <div
      className={classnames(
        `wrapper vertical-layout ${(location.pathname.includes('Publications') && location.pathname !== '/Publications/home') ? 'rlm_Publications_warpper1' : ''} ${navbarWrapperClasses[navbarType] || "navbar-floating"
        } ${footerClasses[footerType] || "footer-static"}`,
        {
          // Modern Menu
          "vertical-menu-modern": windowWidth >= 1200,
          "menu-collapsed": menuCollapsed && windowWidth >= 1200,
          "menu-expanded": !menuCollapsed && windowWidth > 1200,

          // Overlay Menu
          "vertical-overlay-menu": true,
          "menu-hide": !menuVisibility && windowWidth < 992,
          "menu-open": menuVisibility && windowWidth < 992
        }
      )}
      {...(isHidden ? { "data-col": "1-column" } : {})}
    // style={{ height: 'auto' }}
    >
      {!isHidden ? (
        // ((windowWidth > 1200) || (windowWidth <= 1200 && stores?.displayMenuBool)) &&
        <SidebarComponent
          skin={skin}
          menu={menu}
          menuData={menuData}
          menuCollapsed={menuCollapsed}
          menuVisibility={menuVisibility}
          setMenuCollapsed={setMenuCollapsed}
          setMenuVisibility={setMenuVisibility}
        />
      ) : null}
      {/* {headerText &&
        <div className="environment_class">{headerText}</div>
      } */}
      <Navbar
        expand="lg"
        container={false}
        light={skin !== "dark"}
        dark={skin === "dark" || bgColorCondition}
        color={bgColorCondition ? navbarColor : undefined}
        className={classnames(
          `header-navbar navbar align-items-center ${navbarClasses[navbarType] || "floating-nav"
          } navbar-shadow`
        )}
      // style={{ marginTop: headerText ? '0px' : '0px', marginLeft: windowWidth <= 1200 ? '0px' : (store.layout.menuCollapsed ? '225px' : '225px'), marginRight: windowWidth <= 1200 ? '0px' : "11px", width: "auto", borderRadius: "0px" }}
      >
        <div className="navbar-container content">
          {navbar ? (
            navbar({ skin, setSkin, setMenuVisibility })
          ) : (
            <NavbarComponent
              setMenuVisibility={setMenuVisibility}
              skin={skin}
              setSkin={setSkin}
              menuCollapsed={menuCollapsed}
            />
          )}
        </div>
      </Navbar>
      {children}

      {/* Vertical Nav Menu Overlay */}
      <div
        className={classnames("sidenav-overlay", {
          show: menuVisibility
        })}
        onClick={() => setMenuVisibility(false)}
      ></div>
      {/* Vertical Nav Menu Overlay */}

      {themeConfig.layout.customizer === true ? (
        <Customizer
          skin={skin}
          isRtl={isRtl}
          layout={layout}
          setSkin={setSkin}
          setIsRtl={setIsRtl}
          isHidden={isHidden}
          setLayout={setLayout}
          footerType={footerType}
          navbarType={navbarType}
          setIsHidden={setIsHidden}
          themeConfig={themeConfig}
          navbarColor={navbarColor}
          contentWidth={contentWidth}
          setFooterType={setFooterType}
          setNavbarType={setNavbarType}
          setLastLayout={setLastLayout}
          menuCollapsed={menuCollapsed}
          setNavbarColor={setNavbarColor}
          setContentWidth={setContentWidth}
          setMenuCollapsed={setMenuCollapsed}
        />
      ) : null}
      {!catCode &&
        <footer
          className={classnames(
            `footer footer-light ${footerClasses[footerType] || "footer-static"}`,
            {
              "d-none": footerType === "hidden"
            }
          )}
        // style={{ marginLeft: windowWidth <= 1200 ? "-30px" : store.layout.menuCollapsed ? '194px' : '194px' }}
        >
          {footer ? (
            footer
          ) : (
            <FooterComponent
              footerType={footerType}
              footerClasses={footerClasses}
              menuCollapsed={menuCollapsed}
            />
          )}
        </footer>}

      {themeConfig.layout.scrollTop === true ? (
        <div className="scroll-to-top">
          <ScrollToTop showOffset={300} className="scroll-top d-block">
            <Button className="btn-icon" color="primary" style={{ padding: '0.715rem 0.736rem' }}>
              <ArrowUp size={24} />
            </Button>
          </ScrollToTop>
        </div>
      ) : null}

      {((location.pathname !== '/Unauthorized') && (location.pathname !== '/verificationDetails')) ? (<ChatbotWidget />) : null}

    </div>
  )
}

export default VerticalLayout
